module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/BelowDeckMed_S4.0bfabf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/BelowDeckMed_S4.jpg
// module id = GYuR
// module chunks = 0